import React from 'react';
import './CompanySwitcher.css';

const CompanySwitcher = ({ selectedCompany, onCompanyChange }) => {
  return (
    <div className="company-switcher">
      <button 
        className={`switcher-btn ${selectedCompany === 'vietcetera' ? 'active' : ''}`}
        onClick={() => onCompanyChange('vietcetera')}
      >
        Vietcetera
      </button>
      <button 
        className={`switcher-btn ${selectedCompany === 'vnid' ? 'active' : ''}`}
        onClick={() => onCompanyChange('vnid')}
      >
        VNID
      </button>
    </div>
  );
};

export default CompanySwitcher; 